import * as z from 'zod';

import { createModuleLogger } from '#apps/client-web/app/utils/logger';

export const setup = async () => {
  const logger = createModuleLogger('services/mock-service-worker');

  const enabled = z
    .string()
    .default('false')
    .parse(import.meta.env.APP_CLIENT_WEB_MSW_ENABLED);

  logger.info({ enabled }, 'Initializing Mock Service Worker:');

  if (!enabled) {
    logger.info('Mock API is not enabled, skipping MSW setup.');
    return Promise.resolve();
  }

  logger.info('Mock API is enabled, starting MSW worker...');
  // const { worker } = await import('packages/web/src/api/msw-browser');
  // return worker.start();
};

export default { setup };
